// A tiny wrapper around fetch(), borrowed from
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper

import { fetchAuthSession } from 'aws-amplify/auth';

const tokenToString = (token) => {
  if (!token) return '';
  if (typeof token === 'string') return token;
  if (typeof token === 'object' && typeof token.toString === 'function') {
    const value = token.toString();
    return value && value !== '[object Object]' ? value : '';
  }
  return '';
};

const getAuthToken = async () => {
  try {
    const session = await fetchAuthSession();
    const { accessToken, idToken } = session?.tokens ?? {};

    // Prefer ID token for APIs using Cognito authorizers and custom user attributes.
    return tokenToString(idToken) || tokenToString(accessToken) || '';
  } catch (err) {
    console.log('Error getting auth token:', err);
    return '';
  }
};

export async function client(apiURL, endpoint, { body, ...customConfig } = {}) {

    const token = await getAuthToken();

    if (!token) {
      console.warn('No auth token available for API call to', endpoint);
    }

    const headers = { 
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
     }
  
    const config = {
      method: body ? 'POST' : 'GET',
      ...customConfig,
      headers: {
        ...headers,
        ...customConfig.headers,
      },
    }
  
    if (body) {
      config.body = JSON.stringify(body)
    }
  
    let data
    try {
      const response = await window.fetch(`${apiURL}${endpoint}`, config)
      const raw = await response.text()
      data = raw ? JSON.parse(raw) : {}

      if (response.status === 401) {
        console.error(`401 Unauthorized from ${endpoint}`, {
          status: response.status,
          hadToken: !!token,
        });
      }

      if (response.ok) {
        // Return a result object similar to Axios
        return {
          status: response.status,
          data,
          headers: response.headers,
          url: response.url,
        }
      }
      throw new Error(response.statusText)
    } catch (err) {
      return Promise.reject(err.message ? err.message : data)
    }
  }
  
  client.get = function (apiURL, endpoint, customConfig = {}) {
    return client(apiURL, endpoint, { ...customConfig, method: 'GET' })
  }
  
  client.post = function (apiURL, endpoint, body, customConfig = {}) {
    console.log('request body', body)
    return client(apiURL, endpoint, { ...customConfig, body })
  }
  